import { configureRequest } from '../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../networkRequests/apiClient/endpoints'
import {
  ValidateUspsAddressErrorResponse,
  ValidateUspsAddressRequest,
  ValidateUspsAddressSuccessResponse
} from './validateUspsAddress.types'

export const validateUspsAddressApi = async (
  request: ValidateUspsAddressRequest
): Promise<ValidateUspsAddressSuccessResponse> => {
  const response = await configureRequest({
    url: urls.usps.validateAddress,
    method: 'POST',
    data: request
  })

  if (response.status >= 200 && response.status < 300) {
    return response as ValidateUspsAddressSuccessResponse
  } else {
    throw response as ValidateUspsAddressErrorResponse
  }
}

export default validateUspsAddressApi
